import contentService from '../services/contentService'

// ── Labels de estado (mismos que en Calendario / PostDetailModal) ───────────
// El orden de las claves es el orden del flujo; se usa también para el select de estado.
export const STATUS_LABELS = {
  draft: 'Borrador',
  brief_pending: 'Brief Pendiente',
  creative_development: 'Desarrollo Creativo',
  creative_review: 'Revisión Creativa',
  aprobacion_idea: 'Aprobación Idea',
  revision_copy_pendiente: 'Aprobar Copy',
  copy_review: 'Revisión Copy',
  aprobacion_contenido: 'Aprobación Contenido',
  content_review: 'Revisión de Contenido',
  final_review: 'Revisión Final',
  approved: 'Aprobado',
  scheduled: 'Programado',
  published: 'Publicado',
  rejected: 'Rechazado',
  no_publicado: 'No Publicado',
}

// Estados que sacan al post de la lista de vencidos.
export const ESTADOS_QUE_CIERRAN = ['published', 'no_publicado']
export const cierraVencido = (status) => ESTADOS_QUE_CIERRAN.includes(status)

export const getStatusLabel = (status) => STATUS_LABELS[status] || status

export function diasVencido(fecha) {
  const hoy = new Date(); hoy.setHours(0, 0, 0, 0)
  const d = new Date(fecha.slice(0, 10))
  return Math.round((hoy - d) / 86400000)
}

export const sortVencidos = (posts) =>
  [...posts].sort((a, b) => new Date(a.publication_date) - new Date(b.publication_date))

/**
 * Devuelve los posts vencidos: fecha de publicación pasada y que no estén
 * publicados / eliminados / no publicados. Es LA definición de "vencido";
 * la usan la pantalla /vencidos y el modal del Calendario.
 */
export async function fetchVencidos() {
  const hoy = new Date()
  const start = new Date(hoy)
  start.setFullYear(start.getFullYear() - 1) // ventana de 12 meses hacia atrás
  const startStr = start.toISOString().slice(0, 10)
  const endStr = hoy.toISOString().slice(0, 10)

  // lite=true → serializer liviano, suficiente para tabla/modal y más rápido.
  const { data } = await contentService.getCalendar(startStr, endStr, { lite: true })
  const eventos = Array.isArray(data) ? data : (data?.posts || data?.results || data?.events || [])

  const today = new Date(); today.setHours(0, 0, 0, 0)
  const vencidos = eventos.filter(ev => {
    const st = ev.status
    if (st === 'published' || st === 'eliminado' || st === 'no_publicado') return false
    const d = ev.publication_date
    if (!d) return false
    return new Date(d.slice(0, 10)) < today
  })
  return sortVencidos(vencidos)
}
